import { apiResource } from "../../utils";

export function VenueMap({ rows }) {
  return (
    <div style={{ borderRadius: "0.5rem", overflow: "hidden", border: "1px solid #2A2A3E" }}>
      <div className="text-center mb-3">
        <img
          src={apiResource({
            url: rows.image_event
          })}
          alt={rows.name_event}
          className="img-fluid rounded"
          id="concert-image"
          useMap="#image-map"
          style={{ maxHeight: 1350, width: '100%', objectFit: 'contain' }}
        />
        <div className="small text-white mt-2">
          Mapa referencial
        </div>
        <map name="image-map" id="map-mapping" />
      </div>
      <div style={{ padding: "1.5rem", borderTop: "1px solid #2A2A3E" }}>
        <p style={{ fontSize: "0.875rem", color: "var(--text-muted)", textAlign: "center", margin: 0 }}>
          * Plano de ubicación referencial. Puede variar por razones técnicas, logísticas o disposiciones de las
          autoridades competentes.
        </p>
      </div>
    </div>
  )
}
